import { styled } from '@mui/material/styles';
import {
  RADIO_CHECKED_BG_COLOR_VAR,
  RADIO_CHECKED_MAIN_COLOR_VAR,
} from '../../theme/constants/radio';

const FingoCheckedRadio = styled('span', {
  shouldForwardProp: (prop) => prop !== 'size',
})(({ theme, size = 24 }) => ({
  backgroundColor: `var(${RADIO_CHECKED_BG_COLOR_VAR}, ${theme.palette.primary.A100})`,
  borderRadius: '50%',
  border: '1px solid',
  borderColor: `var(${RADIO_CHECKED_MAIN_COLOR_VAR}, ${theme.palette.primary.main})`,
  width: size,
  height: size,
  [theme.breakpoints.down('md')]: {
    width: size * 0.75,
    height: size * 0.75,
  },
  display: 'inline-flex',
  alignItems: 'center',
  justifyContent: 'center',
  position: 'relative',
  '&::after': {
    content: '""',
    width: size * (2 / 3),
    height: size * (2 / 3),
    [theme.breakpoints.down('md')]: {
      width: size * 0.5,
      height: size * 0.5,
    },
    backgroundColor: `var(${RADIO_CHECKED_MAIN_COLOR_VAR}, ${theme.palette.primary.main})`,
    borderRadius: '50%',
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
  },
}));

export default FingoCheckedRadio;
